
import IconAddUser from '@/components/svg/IconAddUser.vue';
import IconCloud from '@/components/svg/IconCloud.vue';
import IconFourSquares from '@/components/svg/IconFourSquares.vue';
import IconUserGroup from '@/components/svg/IconUserGroup.vue';
import { TenantConst } from '@/constants';
import { Namespace } from '@/store/types';
import { eventBus } from '@/utils/eventBus';
import { showUpgradeModal } from '@/utils/upgrade-modal';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

@Component({
  components: {
    IconAddUser,
    IconCloud,
    IconFourSquares,
    IconUserGroup,
  }
})
export default class Usage extends Vue {
  @State('tenantUserCount', { namespace: Namespace.App })
  public tenantUserCount!: number
  @State('tenantExistingJigsCount', { namespace: Namespace.App })
  public tenantExistingJigsCount!: number
  @State('tenantFileSpaceUsed', { namespace: Namespace.App })
  public tenantFileSpaceUsed!: number

  @Getter('isFreeTier', { namespace: Namespace.App })
  public isFreeTier!: boolean
  @Getter('maxJigs', { namespace: Namespace.App })
  public maxJigs!: number
  @Getter('maxSeatsIncluded', { namespace: Namespace.App })
  public maxSeatsIncluded!: number
  @Getter('maxTeamStorageLimitMB', { namespace: Namespace.App })
  public maxTeamStorageLimitMB!: number
  @Getter('isPreparingUsageData', { namespace: Namespace.Utils })
  public isPreparingUsageData!: boolean

  private get jigsMetricTitle(): string {
    if (this.maxJigs === 0) {
      return `${this.tenantExistingJigsCount} Jigs`
    }

    return `${this.tenantExistingJigsCount} of ${this.maxJigs} Jigs`
  }

  private get fileSpaceMetricTitle(): string {
    if (this.maxTeamStorageLimitMB === 0) {
      return `${this.tenantFileSpaceUsed}MB`
    }

    return `${this.tenantFileSpaceUsed}MB of ${this.maxTeamStorageLimitMB}MB`
  }

  private get usersMetricTitle(): string {
    if (this.maxSeatsIncluded === 0) {
      return `${this.tenantUserCount} Seats`
    }

    return `${this.tenantUserCount} of ${this.maxSeatsIncluded} Seats`
  }

  private get jigsUsage(): string {
    if (this.maxJigs === 0) {
      return `width: 0`
    }

    return `width: ${Math.ceil((this.tenantExistingJigsCount / this.maxJigs) * 100)}%`
  }

  private get fileSpaceMetricUsage(): string {
    if (this.maxTeamStorageLimitMB === 0) {
      return `width: 0`
    }

    return `width: ${Math.ceil((this.tenantFileSpaceUsed / this.maxTeamStorageLimitMB) * 100)}%`
  }

  private get usersMetricUsage(): string {
    if (this.maxSeatsIncluded === 0) {
      return `width: 0`
    }

    return `width: ${Math.ceil((this.tenantUserCount / this.maxSeatsIncluded) * 100)}%`
  }

  private get isJigsCloseToLimit(): boolean {
    return this.maxJigs !== 0 && Math.ceil((this.tenantExistingJigsCount / this.maxJigs) * 100) >= 80
  }

  private get isFileSpaceUsedCloseToLimit(): boolean {
    return this.maxTeamStorageLimitMB !== 0 && Math.ceil((this.tenantFileSpaceUsed / this.maxTeamStorageLimitMB) * 100) >= 80
  }

  private get isSeatsUsedCloseToLimit(): boolean {
    return this.maxSeatsIncluded !== 0 && Math.ceil((this.tenantUserCount / this.maxSeatsIncluded) * 100) >= 80
  }

  private get needUpgrade(): boolean {
    if (this.isFreeTier) {
      return true
    }

    return this.isJigsCloseToLimit || this.isFileSpaceUsedCloseToLimit || this.isSeatsUsedCloseToLimit
  }

  private triggerUpgradeModal() {
    showUpgradeModal()
  }

  private handleInvite() {
    if (this.$route.path === '/tenant-users') {
      this.triggerInviteModal()
    } else {
      this.$router.push({
        path: '/tenant-users',
      })
    }
  }

  private triggerInviteModal() {
    eventBus.$emit(TenantConst.tenantUsersEvents.showInviteModal)
  }
}
